import './style.css';

import './js/cargando';
import Map from 'ol/Map';
import View from 'ol/View';
import OSM from 'ol/source/OSM';
import TileLayer from 'ol/layer/Tile';
import {OverviewMap, defaults as defaultControls} from 'ol/control';
import Overlay from 'ol/Overlay';
import {proyeccion3857, centroide3857, fuente} from './js/configuracion';
import LayerSwitcher from 'ol-layerswitcher';
import LayerGroup from 'ol/layer/Group';
import VectorLayer from 'ol/layer/Vector';
import proj4 from 'proj4';
import { register } from 'ol/proj/proj4';

proj4.defs([
  ['EPSG:4326', '+proj=longlat +datum=WGS84 +no_defs'],
  ['EPSG:25829', '+proj=utm +zone=29 +datum=ETRS89 +units=m +no_defs'],
  ['EPSG:25830', '+proj=utm +zone=30 +datum=ETRS89 +units=m +no_defs'],
  ['EPSG:3857', '+proj=merc +a=6378137 +b=6378137 +lat_ts=0 +lon_0=0 +x_0=0 +y_0=0 +k=1 +units=m +nadgrids=@null +wktext +no_defs +type=crs']
]);
register(proj4);

// Grupo de capas
import {grupoBase01} from './js/capasBase';
import {grupoCapa01} from './js/capasCiclo2020-2021';
import {grupoCapa02} from './js/capasIdentificacion';
import {grupoCapa03} from './js/capasEspaciosNaturalesProtegidos';
import {grupoCapa04} from './js/capasHidroperiodo';
import {grupoCapa01_2} from './js/capasCiclo2019-2020';
import {grupoCapa01_3} from './js/capasCiclo2018-2019';
import {grupoCapa01_4} from './js/capasCiclo2017-2018';
import {grupoCapa01_5} from './js/capasCiclo2016-2017';
import {grupoCapa01_6} from './js/capasCiclo2015-2016';
import {grupoCapa01_7} from './js/capasCiclo2014-2015';
import {grupoCapa01_8} from './js/capasCiclo2013-2014';
import {grupoCapa01_9} from './js/capasCiclo2012-2013';
import {grupoCapa01_10} from './js/capasCiclo2011-2012';
import {grupoCapa01_11} from './js/capasCiclo2010-2011';
import {grupoCapa01_12} from './js/capasCiclo2009-2010';
import {grupoCapa01_13} from './js/capasCiclo2008-2009';
import {grupoCapa01_14} from './js/capasCiclo2007-2008';
import {grupoCapa01_15} from './js/capasCiclo2006-2007';
import {grupoCapa01_16} from './js/capasCiclo2005-2006';
import {grupoCapa01_17} from './js/capasCiclo2004-2005';
import {grupoCapa01_18} from './js/capasCiclo2003-2004';
import {grupoCapa01_19} from './js/capasCiclo2002-2003';
import {grupoCapa01_20} from './js/capasCiclo2001-2002';
import {grupoCapa01_21} from './js/capasCiclo2000-2001';
import {grupoCapa01_22} from './js/capasCiclo1999-2000';
import {grupoCapa01_23} from './js/capasCiclo1998-1999';
import {grupoCapa01_24} from './js/capasCiclo1997-1998';
import {grupoCapa01_25} from './js/capasCiclo1996-1997';
import {grupoCapa01_26} from './js/capasCiclo1995-1996';
import {grupoCapa01_27} from './js/capasCiclo1994-1995';
import {grupoCapa01_28} from './js/capasCiclo1993-1994';
import {grupoCapa01_29} from './js/capasCiclo1992-1993';
import {grupoCapa01_30} from './js/capasCiclo1991-1992';
import {grupoCapa01_31} from './js/capasCiclo1990-1991';
import {grupoCapa01_32} from './js/capasCiclo1989-1990';
import {grupoCapa01_33} from './js/capasCiclo1988-1989';
import {grupoCapa01_34} from './js/capasCiclo1987-1988';
import {grupoCapa01_35} from './js/capasCiclo1986-1987';
import {grupoCapa01_36} from './js/capasCiclo1985-1986';
import {grupoCapa01_37} from './js/capasCiclo1984-1985';

// Controles
const popup = document.getElementById('popup'),
cerrar = document.getElementById('popup-closer');
global.contenido = document.getElementById('popup-content');

global.overlay = new Overlay({element: popup ,autoPan: {animation: {duration: 250,},},});
const overviewMapControl = new OverviewMap({className: 'ol-overviewmap ol-custom-overviewmap', tipLabel: ' ', layers: [new TileLayer({source: new OSM(),}),],collapseLabel: '\u00BB', label: '\u00AB',collapsed: false,});
const controles = defaultControls({zoom: false, attribution: false, rotate: true}).extend([overviewMapControl]);
function actualizarControlOverview()
{
  const button = document.querySelector('.ol-custom-overviewmap');
  if (button){
    button.setAttribute('data-bs-toggle', 'tooltip');
    button.setAttribute('data-bs-placement', 'top');
    button.setAttribute('data-bs-title', 'Ver mapa general');
  }
}
function actualizarControlCapas()
{
  const button = document.querySelector('button[title="Cerrar"]');
  if (button){
    button.setAttribute('data-bs-toggle', 'tooltip');
    button.setAttribute('data-bs-placement', 'top');
    button.setAttribute('data-bs-title', 'Capas temáticas');
  }
}

// Cargar archivos, dibujo y interoperabilidad
global.dibujoGeometria = new VectorLayer({id: 'dibujoGeometria', title: 'Graficar sobre el mapa', source: fuente, projection: proyeccion3857,});
global.grupoCapasExternos = new LayerGroup({title: 'Capas externas', fold: 'open', layers: [global.dibujoGeometria]});
global.gruposDeCapas = [grupoBase01, global.grupoCapasExternos, grupoCapa03, grupoCapa02, grupoCapa04, grupoCapa01, grupoCapa01_2, grupoCapa01_3, grupoCapa01_4, grupoCapa01_5, grupoCapa01_6, grupoCapa01_7, grupoCapa01_8, grupoCapa01_9, grupoCapa01_10, grupoCapa01_11, grupoCapa01_12, grupoCapa01_13, grupoCapa01_14, grupoCapa01_15, grupoCapa01_16, grupoCapa01_17, grupoCapa01_18, grupoCapa01_19, grupoCapa01_20, grupoCapa01_21, grupoCapa01_22, grupoCapa01_23, grupoCapa01_24, grupoCapa01_25, grupoCapa01_26, grupoCapa01_27, grupoCapa01_28, grupoCapa01_29, grupoCapa01_30, grupoCapa01_31, grupoCapa01_32, grupoCapa01_33, grupoCapa01_34, grupoCapa01_35, grupoCapa01_36, grupoCapa01_37];

/*
  Principal
*/
global.vista = new View({projection: proyeccion3857, center: centroide3857, zoom: 11});
global.mapa = new Map({target: 'map', layers: gruposDeCapas, view: global.vista, controls: controles, overlays: [global.overlay],});
global.layerSwitcher = new LayerSwitcher({activationMode: 'click', startActive: true, groupSelectStyle: 'children', reverse: false, collapseTipLabel: 'Cerrar',collapseLabel: '\u00BB', tipLabel: 'Cerrar'});
global.mapa.addControl(global.layerSwitcher);

// 0. Mouse Posición - Escala
import { mousePosicion, actualizarEscala } from './js/controlMousePosicionEscala';
global.mapa.on('pointermove', mousePosicion);
global.mapa.getView().on('change:resolution', actualizarEscala);
global.mapa.once('rendercomplete', function(){actualizarEscala();});

// 1. Barra de controles
import './js/barraControles';

// 2. Control de Mas y Menos
import './js/controlVistaInicioMasMenos';

// 3. Obtener información || 9. Obtener coordenadas
import { obtenerInformacion } from './js/controlObtenerInformacion';
import { obtenerCoordenadas } from './js/controlObtenerCoordenadas';
global.mapa.on('click', function(e){obtenerInformacion(e); obtenerCoordenadas(e);});
cerrar.onclick = function () {cerrar.blur(); return false;};

// 4. Buscar localidad
import './js/controlBuscar';

// 5. Cargar un archivo Zip y/o Kml
import './js/controlCargarArchivoZipKml';

// 6. Graficar sobre el mapa
import './js/controlGraficar';

// 7. Conectarse a servicios
import './js/controlConectarServicios';

// 8. Ubicar coordenadas
import './js/controlUbicarCoordenadas';

// 10. Medir y/o calcular superficie
import './js/controlCalcularDistanciaArea';

// 11. Movil y/o Tableta
if (window.innerWidth <= 1366)
{
  global.layerSwitcher.hidePanel();
  overviewMapControl.setCollapsed(true);
  actualizarEscala();
  global.vista.setZoom(10.5);
}

actualizarControlCapas();
actualizarControlOverview();